import { useEffect, useRef } from 'react'

export function GrainVignette({ reducedMotion = false }) {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const context = canvas.getContext('2d')
    const size = 180
    let frame = 0
    let hidden = document.hidden

    canvas.width = size
    canvas.height = size

    const draw = () => {
      const image = context.createImageData(size, size)
      for (let i = 0; i < image.data.length; i += 4) {
        const shade = 110 + Math.random() * 90
        image.data[i] = shade
        image.data[i + 1] = shade
        image.data[i + 2] = shade
        image.data[i + 3] = 22
      }
      context.putImageData(image, 0, 0)
    }

    const animate = () => {
      if (!hidden) draw()
      if (!reducedMotion) frame = requestAnimationFrame(animate)
    }

    const onVisibility = () => {
      hidden = document.hidden
    }

    draw()
    if (!reducedMotion) frame = requestAnimationFrame(animate)
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      cancelAnimationFrame(frame)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [reducedMotion])

  return (
    <div className="film-overlay" aria-hidden="true">
      <canvas ref={canvasRef} className="film-overlay__grain" />
      <div className="film-overlay__vignette" />
      <div className="film-overlay__letterbox film-overlay__letterbox--top" />
      <div className="film-overlay__letterbox film-overlay__letterbox--bottom" />
    </div>
  )
}
